import { PartDto } from "#modules/parts/infra/fetchPart.api";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { ValidateButton } from "#modules/quoteRequests/view/ValidateButton";
import { Icon } from "#shared/icons/Icon";
import { ActionIcon } from "#shared/view/components/ActionIcon";
import { Flex } from "#shared/view/components/Flex";
import { Menu } from "#shared/view/components/Menu";
import { Space } from "#shared/view/components/Space";

import { PartHeader } from "../QuoteRequestLine/PartHeader";

type Props = {
  part: PartDto;
  quoteRequestLine: QuoteRequestLineDto | undefined;
  isCommentVisible: boolean;
  onDisplayComment: () => void;
  onClosePanel: () => void;
  hasChildren: boolean;
};

export const DetailsPanelHeader = ({
  part,
  quoteRequestLine,
  isCommentVisible,
  onDisplayComment,
  onClosePanel,
  hasChildren,
}: Props) => {
  if (!quoteRequestLine) {
    return null;
  }

  return (
    <Flex pos="relative">
      <PartHeader
        quoteRequestLine={quoteRequestLine}
        hasChildren={hasChildren}
        isConsumable={false}
        thumbnailSize={{ width: 100, height: 100 }}
        fontSize={24}
        part={part}
        showWeight
      />

      <Flex justify={"flex-end"} w="100%">
        <Menu position="bottom-end">
          <Menu.Target>
            <ActionIcon size="lg">
              <Icon name="moreHorizontal" size={24} />
            </ActionIcon>
          </Menu.Target>

          <Menu.Dropdown>
            <Menu.Item
              onClick={onDisplayComment}
              disabled={isCommentVisible}
              leftSection={<Icon name="comment" size={14} />}
            >
              Ajouter un commentaire
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
        <Space w="xs" />
        <ValidateButton quoteRequestLine={quoteRequestLine} onValidate={onClosePanel} />
        <Space w="xs" />
        <ActionIcon size="lg" onClick={onClosePanel}>
          <Icon name="x" size={24} />
        </ActionIcon>
      </Flex>
    </Flex>
  );
};
